import client from './index'
import store from '@/store'

// Common
const downloadFile = (url, data = {}) => client['api'].get(url, { responseType: 'blob', params: data})
// thesis
const getDataThesis = (data) => client['api'].get(`thesis`, {params: data})
const storeThesis = (data) => client['api'].post(`thesis`, data, {"Content-Type": "multipart/form-data",  onUploadProgress: progressEvent => {
    let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
    store.dispatch('setLoading',percentCompleted)
}})
const updateThesis = (data, id) => client['api'].post(`thesis/${id}`, data, {"Content-Type": "multipart/form-data",  onUploadProgress: progressEvent => {
    let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
    store.dispatch('setLoading',percentCompleted)
}})
const perpanjanganThesis = (id) => client['api'].post(`thesis/perpanjangan/${id}`)
const destroyThesis = (id) => client['api'].delete(`thesis/${id}`)

// Verify
const kaprodiVerify = (data, id) => client['api'].post(`thesis/kaprodiverify/${id}`, data)
const lectureVerify = (id,status) => client['api'].post(`thesis/lecture/${id}/${status}`)


export {
    downloadFile,
    getDataThesis,
    storeThesis,
    updateThesis,
    destroyThesis,
    perpanjanganThesis,
    kaprodiVerify,
    lectureVerify
}